const Steps = {
  identification: 0,
  signup: 1,
  emailValidation: 2,
  validatedEmail: 3
}

export default Steps;
